var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"font-bold text-lg main-font primary-text"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }